// src/registerServiceWorker.js
import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('App is served from cache by SW')
    },
    updated(registration) {
      // 有新版本
      if (registration.waiting) {
        // 1. 让 SW 跳过等待
        registration.waiting.postMessage({ type: 'SKIP_WAITING' })
        // 2. 通知页面刷新
        registration.waiting.addEventListener('statechange', (e) => {
          if (e.target.state === 'activated') {
            // 全部标签页重载
            window.location.reload()
          }
        })
      }
    }
  })
}
